// Centralized cohort configuration
// Update this file to change cohort dates across the entire application

export const COHORT_CONFIG = {
  // Next cohort start date
  startDate: new Date("2026-01-05"),
  
  // Formatted display strings
  get displayDate() {
    return this.startDate.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric", 
      year: "numeric"
    });
  },
  
  // Common text patterns used throughout the app
  get reserveButtonText() {
    return `Reserve for ${this.displayDate} Cohort`;
  },
  
  get joinCohortText() {
    return `Join our ${this.displayDate} cohort`;
  },
  
  get cohortBeginsText() {
    return `Next cohort begins ${this.displayDate}`;
  },
  
  get contentAvailableText() {
    return `Full course content will be available ${this.displayDate}`;
  },
  
  get cohortStartingText() {
    return `Join our cohort starting ${this.displayDate} and gain the expertise needed to lead with confidence in the AI era.`;
  }
} as const;
